<template>
  <!-- Barra CONFIG (solo standalone), como la de vue-file-transform: perfil de cliente
       (config/<cliente>/client.config.js: URL de servicios + bearer), idioma y prueba de conexión. -->
  <div class="cfg">
    <span class="cfg-badge">CONFIG</span>
    <template v-if="profiles.length">
      <label class="cfg-ctl">{{ t('cfg.profile') }}
        <select v-model="state.profile">
          <option v-for="p in profiles" :key="p.key" :value="p.key">{{ p.label }}</option>
        </select>
      </label>
      <label class="cfg-ctl">{{ t('cfg.lang') }}
        <select v-model="state.lang">
          <option v-for="l in current?.langs || []" :key="l" :value="l">{{ l }}</option>
        </select>
      </label>
      <span class="cfg-state" :class="{ on: !!current?.token }">{{ current?.token ? '● ' + t('cfg.tokenOk') : '○ ' + t('cfg.tokenMissing') }}</span>
      <span class="cfg-url">{{ current?.baseUrl }}</span>
      <button type="button" class="cfg-btn" :disabled="testing" @click="test">{{ testing ? '…' : t('cfg.test') }}</button>
      <span v-if="result" class="cfg-res" :class="result.ok ? 'ok' : 'err'">{{ result.text }}</span>
    </template>
    <span v-else class="cfg-res err">{{ t('cfg.noProfiles') }}</span>
    <span class="cfg-help">{{ t('cfg.help') }}</span>
  </div>
</template>

<script setup>
import { computed, inject, reactive, ref, watch } from 'vue';
import { locale, normalizeLang, t } from '@vem/i18n.js';
import { getRuntimeConfig, saveRuntimeConfig } from '@vem/config/runtimeConfig.js';
import { listDefs } from '@vem/api/materializeApi.js';

const emit = defineEmits(['changed']);
const profiles = inject('clientProfiles', []);
const cfg0 = getRuntimeConfig();
const state = reactive({
  profile: profiles.some((p) => p.key === cfg0.profile) ? cfg0.profile : profiles[0]?.key || '',
  lang: cfg0.lang,
});
const current = computed(() => profiles.find((p) => p.key === state.profile) || null);
const testing = ref(false);
const result = ref(null);

function apply() {
  const p = current.value;
  if (!p) return;
  if (!p.langs.includes(state.lang)) state.lang = p.langs[0];
  saveRuntimeConfig({ profile: p.key, baseUrl: p.baseUrl, token: p.token, lang: state.lang, rawToken: false });
  locale.value = normalizeLang(state.lang);
}

async function test() {
  testing.value = true;
  result.value = null;
  try {
    const defs = await listDefs();
    result.value = { ok: true, text: t('cfg.testOk', { n: defs.length }) };
  } catch (e) {
    result.value = { ok: false, text: e.message };
  } finally {
    testing.value = false;
  }
}

apply();
watch(() => state.profile, () => { apply(); emit('changed'); });
watch(() => state.lang, () => { apply(); emit('changed'); });
</script>
